module.exports = __webpack_public_path__ + "static/img/voc_brand_logo.5de19e.png";